import { Button } from '@chakra-ui/react'
import { LiveInputDetail } from '@features/liveInputs/components/LiveInputDetail'
import { createFileRoute, getRouteApi, Link } from '@tanstack/react-router'
import { FaArrowLeft } from 'react-icons/fa6'
import { Route as liveInputListRoute } from '@routes/_auth/o/$orgId/liveInputs'

const routeApi = getRouteApi('/_auth/o/$orgId/liveInputs/$liveInputId')

const BackButton = () => {
  const { orgId } = routeApi.useParams()
  return (
    <Link to={liveInputListRoute.to} params={{ orgId }}>
      <Button leftIcon={<FaArrowLeft />} size="xs">
        Back to List
      </Button>
    </Link>
  )
}

const LiveInputDetailRoute = () => {
  const { liveInputId } = routeApi.useParams()

  return (
    <>
      <BackButton />
      <LiveInputDetail liveInputId={liveInputId} />
    </>
  )
}

export const Route = createFileRoute('/_auth/o/$orgId/liveInputs/$liveInputId')(
  {
    component: LiveInputDetailRoute,
    beforeLoad: () => ({ getTitle: () => 'Live Input' }),
    loader: () => ({
      crumb: 'Input',
    }),
  }
)
